import { takeLatest, call } from 'redux-saga/effects';
import actionTypes from 'store/auth/actionTypes';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import history from '../../../utils/history';

export function* recoverPasswordGen(payload) {
  const { password, token } = payload.payload;
  try {
    yield call(api, {
      method: 'post',
      url: URL.RECOVER_PASSWORD,
      data: {
        password,
        key: token,
      },
    });
    history.push('/auth/password_change_success');
  } catch (e) {
    yield call(toast.error, 'Error');
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.RECOVER_PASSWORD, recoverPasswordGen);
}
